import React, { useEffect } from "react";
import moment from "moment";
import { Link } from "react-router-dom";
function TableData({ prop, setPage, currentPage, totalPages, student,all  }) {
  const data = prop;

  const formatDate = (isoDate) => {
    try {
      const parsedDate = moment(isoDate);
      if (!parsedDate.isValid()) {
        return "Invalid Date"; // Handle invalid date strings
      }
      return parsedDate.format("MM/DD/YYYY"); // Change format as needed
    } catch (error) {
      console.error("Error occurred while parsing date:", error);
      return "Error";
    }
  };

  useEffect(()=>{
console.log(prop)
  },[])

  return (
    <div className="pt-2 ">
      <div className="flex justify-center ">
        <button
          className={`bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded-l ${
            currentPage === 1 ? " opacity-0" : ""
          }`}
          onClick={() => setPage(currentPage - 1)}
          disabled={currentPage === 1}
        >
          Previous
        </button>
        <span className="bg-gray-300 text-gray-800 font-bold py-2 px-4">
          Page {currentPage} of {totalPages}
        </span>
        <button
          className={` bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded-r ${
            currentPage === totalPages ? " opacity-0" : ""
          }`}
          onClick={() => setPage(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>
      <table className="border w-full">
        <thead className="bg-richblack-500 text-yellow-100">
          <tr className="bg-gray-200">
            {student && (
              <>
                <th className="border p-3 border-black">Student Name</th>
                <th className="border p-3 border-black">Library ID</th>
              </>
            )}

            <th className="border p-3 border-black">Book Name</th>
            <th className="border p-3 border-black">Book ID</th>
            <th className="border p-3 border-black">Book Issued Date</th>
            <th className="border p-3 border-black">Book Return Date</th>
            <th className="border p-3 border-black">Fine</th>
          </tr>
        </thead>

        <tbody>
          {data?.map((one) => (
            <tr key={one._id} className="w-full">
            {student && (
              <>
                <td className="border p-3 border-black">
                <Link to={`/dashboard/student/${one.studentDetails?._id}`}>
                {one.studentDetails?.firstName}{" "}{one.studentDetails?.lastName} <br />{one.studentDetails?.className}
                </Link>
                </td>
                <td className="border p-3 border-black">{one.studentDetails?.libraryId}</td>
              </>
            )}
              <td className="border p-3 text-center lg:text-xl font-mulish">
                {one.bookDetails?.bookName}
              </td>
              <td className="border p-3 text-center lg:text-xl font-mulish">
                {one.bookDetails?.bookID}
              </td>
              <td className="border p-3 text-center lg:text-xl font-mulish">
             { formatDate(one?.bookIssuedDate) }
              </td>
              <td className="border p-3 text-center lg:text-xl font-mulish">
                {!one.bookRetunDate ? (
                  <p className="bg-red rounded-lg p-2 mx-auto text-center text-white">
                    Not Returned
                  </p>
                ) : (
                  formatDate(one.bookRetunDate)
                )}
              </td>
              <td className="border p-3 text-center lg:text-xl font-mulish">
              Rs.   {" "} {one.lateFine}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="flex justify-center mt-4">
        <button
          className={`bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded-l ${
            currentPage === 1 ? " opacity-0" : ""
          }`}
          onClick={() => setPage(currentPage - 1)}
          disabled={currentPage === 1}
        >
          Previous
        </button>
        <span className="bg-gray-300 text-gray-800 font-bold py-2 px-4">
          Page {currentPage} of {totalPages}
        </span>
        <button
          className={` bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded-r ${
            currentPage === totalPages ? " opacity-0" : ""
          }`}
          onClick={() => setPage(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>
    </div>
  );
}

export default TableData;
